export default __webpack_public_path__ + "static/media/instagram.0c6a5c7e.png";